import { render } from "./ImgCard.vue?vue&type=template&id=a88c28da&scoped=true"
import script from "./ImgCard.vue?vue&type=script&lang=js"
export * from "./ImgCard.vue?vue&type=script&lang=js"

import "./ImgCard.vue?vue&type=style&index=0&id=a88c28da&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88c28da"]])

export default __exports__